import {
  CREATED_NEW_JOB,
  JOB_DELETED,
  JOB_UPDATED,
  SET_SELECTED_JOB, UPDATE_ALL_COMPANY_JOBS, UPDATE_ALL_JOBS
} from "../actions/";

const jobsReducer = (
  state = {
    // initial state
    allJobs: [],
    companyJobs: [],
    selectedJob: null,
    newJobCreated: false,
    jobUpdated: false,
    jobDeleted: false,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALL_JOBS:
      return {
        ...state,
        allJobs: [...action.jobs],
        newJobCreated: false,
        jobUpdated: false,
        jobDeleted: false,
      };   
    case UPDATE_ALL_COMPANY_JOBS:
      return {
        ...state,
        companyJobs: [...action.companyJobs]
      };
    case CREATED_NEW_JOB:
      return {
        ...state,
        newJobCreated: true,
        selectedJob: action.job ,
      };
    case JOB_UPDATED:
      return {
        ...state,
        jobUpdated: true,
      };
    case JOB_DELETED:
      return {
        ...state,
        jobDeleted: true,
      };

    case SET_SELECTED_JOB:
      return {
        ...state,
        selectedJob: action.job ,
      };


    default:
      return state;
  }
};

export default jobsReducer;
